export const enterpriseOrganizationColorMap = [
  {
    color: '#fff',
    backgroundColor: 'indigo.500',
  },
  {
    color: '#fff',
    backgroundColor: 'indigo.300',
  },
  {
    color: '#fff',
    backgroundColor: 'indigo.100',
  },
  {
    color: '#fff',
    backgroundColor: 'yellow.900',
  },
  {
    color: '#fff',
    backgroundColor: 'yellow.400',
  },
  {
    color: '#EE8B02',
    backgroundColor: 'yellow.100',
    enterprise: '#FDF5E0',
  },
  {
    color: '#fff',
    backgroundColor: 'grey.900',
  },
  {
    color: '#fff',
    backgroundColor: 'grey.600',
  },
  {
    color: '#fff',
    backgroundColor: 'grey.400',
  },
  {
    color: '#fff',
    backgroundColor: 'green.900',
  },
  {
    color: '#fff',
    backgroundColor: 'green.400',
  },
  {
    color: '#147B4A',
    backgroundColor: 'green.200',
  },
  {
    color: '#fff',
    backgroundColor: 'red.900',
  },
  {
    color: '#fff',
    backgroundColor: 'red.400',
  },
  {
    color: '#8C0B03',
    backgroundColor: 'red.100',
  },
  {
    color: '#fff',
    backgroundColor: 'aqua.800',
  },
  {
    color: '#fff',
    backgroundColor: 'aqua.600',
  },
  {
    color: '#004F5A',
    backgroundColor: 'aqua.100',
    enterprise: 'aqua.300',
  },
  {
    color: '#fff',
    backgroundColor: 'blue.800',
  },
  {
    color: '#fff',
    backgroundColor: 'blue.500',
  },
  {
    color: '#fff',
    backgroundColor: 'blue.900',
  },
];
